module.exports = "../study/imgs/maps/Kanagawa/S8/WaterEnvironment/Chlmax/Kanagawa_Chlmax_MIROC5_RCP45_End.png";